export const getFs = () => {
    if (typeof window !== 'undefined') {
        throw new Error('File system operations are not supported in browser environments');
    }
    try {
        return require('fs');
    }
    catch (error) {
        console.error(error);
        throw new Error('Failed to load file system module');
    }
};
//# sourceMappingURL=fs.js.map